export default __webpack_public_path__ + "static/media/companies-logo.a81057da.png";